import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-progress-spinner-dialog',
    templateUrl: './progress-spinner-dialog.component.html',
    styleUrls: ['./progress-spinner-dialog.component.scss'],
    standalone: false
})
export class ProgressSpinnerDialogComponent implements OnInit {
  ngOnInit() {
    // intentionally empty
  }
}
